module.exports = __webpack_public_path__ + "img/title-logo.f3a722d8.png";